import { gql } from '@apollo/client';

/** Sidebar permission/count check; the campaign list loads its own full document. */
export const CAMPAIGN_AUDIT_ACCESS = gql`
  query CampaignAuditAccess {
    adminCpmCampaigns(limit: 1) {
      total
    }
  }
`;
export type CampaignAuditAccessData = { adminCpmCampaigns: { total: number } };
